import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 p-4 bg-white rounded-3 mb-4" }
const _hoisted_2 = { class: "row align-items-end" }
const _hoisted_3 = { class: "col-lg-8 col-md-7" }
const _hoisted_4 = { class: "me-plus-27 mb-4 mb-md-0" }
const _hoisted_5 = { style: {"margin":"-23px -9px -27px -17px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex flex-wrap gap-2 justify-content-between mb-30 pb-lg-2" }, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", { class: "mb-1" }, "Analytics Overview"),
        _createElementVNode("span", null, "Track, Analyze, and Optimize Performance")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", { class: "analytics-tabs d-flex list-unstyled ps-0 mb-0" }, [
          _createElementVNode("li", null, [
            _createElementVNode("button", null, "Day")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "active" }, "Week")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", null, "Month")
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isClient)
              ? (_openBlock(), _createBlock(_component_apexchart, {
                  key: 0,
                  type: "bar",
                  height: "375",
                  options: _ctx.analyticsOverview,
                  series: _ctx.analytics
                }, null, 8, ["options", "series"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-4 col-md-5" }, [
        _createElementVNode("div", { class: "ms-minus-27" }, [
          _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2 pb-1" }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", { class: "fs-12 d-block mb-1 text-secondary" }, "New Users"),
                _createElementVNode("h4", { class: "fs-16 mb-0" }, "19.5k")
              ]),
              _createElementVNode("div", { class: "text-end" }, [
                _createElementVNode("span", { class: "fs-12 d-block mb-1" }, "Goal Reached"),
                _createElementVNode("h4", { class: "fs-16 mb-0 text-body" }, "75%")
              ])
            ]),
            _createElementVNode("div", {
              class: "progress rounded-pill",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "75",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary rounded-pill",
                style: {"width":"75%","height":"4px"}
              })
            ])
          ]),
          _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2 pb-1" }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", { class: "fs-12 d-block mb-1 text-secondary" }, " Page Views "),
                _createElementVNode("h4", { class: "fs-16 mb-0" }, "48k")
              ]),
              _createElementVNode("div", { class: "text-end" }, [
                _createElementVNode("span", { class: "fs-12 d-block mb-1" }, "Goal Reached"),
                _createElementVNode("h4", { class: "fs-16 mb-0 text-body" }, "45%")
              ])
            ]),
            _createElementVNode("div", {
              class: "progress rounded-pill",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "45",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary-div rounded-pill",
                style: {"width":"45%","height":"4px"}
              })
            ])
          ]),
          _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2 pb-1" }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", { class: "fs-12 d-block mb-1 text-secondary" }, " Page Sessions "),
                _createElementVNode("h4", { class: "fs-16 mb-0" }, "33.3k")
              ]),
              _createElementVNode("div", { class: "text-end" }, [
                _createElementVNode("span", { class: "fs-12 d-block mb-1" }, "Goal Reached"),
                _createElementVNode("h4", { class: "fs-16 mb-0 text-body" }, "55%")
              ])
            ]),
            _createElementVNode("div", {
              class: "progress rounded-pill",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "55",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary rounded-pill",
                style: {"width":"55%","height":"4px"}
              })
            ])
          ]),
          _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2 pb-1" }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", { class: "fs-12 d-block mb-1 text-secondary" }, " Bounce Rate "),
                _createElementVNode("h4", { class: "fs-16 mb-0" }, "22.45%")
              ]),
              _createElementVNode("div", { class: "text-end" }, [
                _createElementVNode("span", { class: "fs-12 d-block mb-1" }, "Goal Reached"),
                _createElementVNode("h4", { class: "fs-16 mb-0 text-body" }, "35%")
              ])
            ]),
            _createElementVNode("div", {
              class: "progress rounded-pill",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "30",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-danger rounded-pill",
                style: {"width":"30%","height":"4px"}
              })
            ])
          ])
        ])
      ], -1))
    ])
  ]))
}